<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="regis flex flex-center">
      <div class="regis-inner">
        <el-card shadow="hover" class="regis-card">
          <div class="regis-title">
            {{ demandId ? "修改" : "发布" }}检测需求
          </div>
          <DetailForm />
        </el-card>
      </div>
    </div>
    <FootBar />
  </div>
</template>
<script>
import DetailForm from "@/components/RequirementDetail/index";

export default {
  components: { DetailForm },
  data() {
    return {
      demandId: null,
    };
  },

  created() {
    this.demandId = this.$route.query.id;
  },
  methods: {
    handlePreview() {},
    handleRemove() {},
    handleExceed() {},
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
$width: 800px;
.regis {
  &-inner {
    width: $width;
    max-width: $width;
    padding-top: 30px;
    min-height: 500px;
    margin-bottom: 30px;
  }
  &-title {
    margin-bottom: 50px;
    text-align: center;
    font-size: 20px;
  }
}
</style>
